// 获取注册内容弹窗组件
export function getdatafillingDialogData() {
    return [

        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'radio',
            isNull: false,

        }, {
            key: "nation",
            name: "民族",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "political",
            name: "政治面貌",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'input',
            isNull: false,

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "stuStatusNum",
            name: "中职学籍号",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "edSystem",
            name: "学制",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "school",
            name: "中职学校名称",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "profession",
            name: "中职专业名称",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "schoolAddress",
            name: "学校地址",
            value: '',
            type: 'input',
            isNull: false,

        }, {
            key: "readyProfession",
            name: "报考专业",
            value: '',
            type: 'select',
            options: [{
                    labe: '计算机科学与技术',
                    value: '计算机科学与技术'
                },
                {
                    labe: '电子商务',
                    value: '电子商务'
                },
                {
                    labe: '财务管理',
                    value: '财务管理'
                },
            ],
            isNull: false,

        }, {
            key: "statusCheckFile",
            name: "学籍资料审核表",
            fileList: [],
            fileName: '',
            uploadTitle: "学籍资料审核表",
            type: 'uploadList',
            isNull: false,

        }, {
            key: "stuStatusFile",
            name: "所在学校学籍表",
            fileList: [],
            fileName: '',
            uploadTitle: "所在学校学籍表",
            type: 'uploadList',
            isNull: false,

        }, {
            key: "idCardFile",
            name: "身份证图片",
            idcardImgLIst: [{
                    pathflag: 0,
                    path: require("../../assets/img/sfzf.png"),
                    info: "点击上传身份证人像面图片",
                },
                {
                    pathflag: 0,
                    path: require("../../assets/img/sfzz.png"),
                    info: "点击上传身份证国徽面图片",
                },
            ],
            idCardflag: '0',
            uploadTitle: "身份证图片",
            type: 'idcardImg',
            isNull: false,

        },
        {
            key: "withoutTestFile",
            name: "免试",
            fileList: [],
            fileName: '',
            uploadTitle: "免试",
            type: 'uploadList',
            isNull: true,

        }, {
            key: "otherScoreFile",
            name: "加分",
            fileList: [],
            fileName: '',
            uploadTitle: "加分",
            type: 'uploadList',
            isNull: true,

        },

    ]
}